import React from "react";
import { useFeatureFlag } from "~/config/ff";
import SiteLoader from "../site-loader/SiteLoader";
import Forbidden from "~/Pages/Forbidden";

function FeatureFlagged({ flag, children }) {
  const { value, isLoading } = useFeatureFlag(flag, false);

  if (isLoading) return <SiteLoader />;

  if (!value) return <Forbidden />;

  return children;
}

export default FeatureFlagged;
